import Image from 'next/image'
import { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'

import { useAppSelector } from 'store/store'

import { selectAllGiftPackageIndex, selectPackageForProduct } from '@/entities/cart'
import { Gift } from '@/entities/cart'
import { selectAllGiftPackagesByProduct, selectProductGiftConfig } from '@/entities/cart/selectors'

import { BASE_URL } from '@/shared/lib/const/env'
import { Button } from '@/shared/ui/Button'
import { FullScreenModal } from '@/shared/ui/full-screen-modal/ui/full-screen-modal'
import { Modal } from '@/shared/ui/Modal'
import { Text } from '@/shared/ui/Typography'

import cl from './gifts-packages-modal.module.scss'

export type GiftsPackagesModalProps = {
	productId: number
	isOpen: boolean
	onClose: () => void
}

export const GiftsPackagesModal = (props: GiftsPackagesModalProps) => {
	const { productId, isOpen, onClose } = props

	const dispatch = useDispatch()

	// НОВАЯ АРХИТЕКТУРА: читаем из ProductGiftConfig
	const config = useAppSelector(selectProductGiftConfig(productId))
	const packagesNew = config?.availablePackages || []

	// СТАРАЯ ЛОГИКА (deprecated, fallback):
	const packagesOld = useAppSelector(selectAllGiftPackagesByProduct(productId))

	// Используем новую архитектуру если доступна, иначе старую
	const packages = packagesNew.length > 0 ? packagesNew : packagesOld
	const [isDesktop, setIsDesktop] = useState(false)

	useEffect(() => {
		setIsDesktop(window.matchMedia('(min-width: 768px)').matches)
	}, [])

	const modalContent = useMemo(
		() => (
			<div className={cl.root}>
				<h2 className={cl.heading}>Выберите пакет подарков</h2>
				<div className={cl.gridWrapper}>
					<div className={cl.grid}>
						{packages.map((pkg: Gift[], idx: number) => (
							<div key={idx} className={cl.packageCard}>
								<div className={cl.packagePreview}>
									{pkg.map(gift => (
										<div key={gift.ID} className={cl.item}>
											<div className={cl.itemImg}>
												<Image src={BASE_URL + gift.IMAGE} width={64} height={64} alt={gift.TITLE} />
											</div>
											<Text className={cl.itemTitle}>{gift.TITLE}</Text>
										</div>
									))}
								</div>
								<div className={cl.footer}>
									<Button
										onClick={() => {
											console.log(`[GiftsPackagesModal] Выбран пакет ${idx} для товара ${productId}`)
											// НОВАЯ АРХИТЕКТУРА: обновляем ProductGiftConfig
											dispatch(selectPackageForProduct({ productId, packageIndex: idx }))
											// СТАРАЯ ЛОГИКА (deprecated):
											dispatch(selectAllGiftPackageIndex({ productId, index: idx }))
											onClose()
										}}>
										Добавить
									</Button>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		),
		[packages, productId, dispatch, onClose]
	)

	return (
		<>
			<Modal isOpen={isDesktop ? isOpen : false} onClose={onClose} className={cl.modal} contentClassName={cl.content}>
				{modalContent}
			</Modal>
			<FullScreenModal open={isDesktop ? false : isOpen} onClose={onClose}>
				{modalContent}
			</FullScreenModal>
		</>
	)
}
